import { useCallback, useEffect, useState } from "react";
import {
  Table,
  Button,
  Form,
  Tabs,
  Tab,
  Pagination,
  Dropdown,
  ButtonGroup,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import "./Content.css";
import {
  faCaretDown,
  faCaretUp,
  faEye,
  faPen,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../../Pages/hooks/useAxiosPrivate";
import { ACADEMACYEARSDASHBORD, baseURL, DELETACASEC } from "../../../API/API";
import { BsExclamationTriangleFill } from "react-icons/bs";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { useDataRefresh } from "../../../Pages/context/DataRefreshContext";

export default function Content() {
  const [activeTab, setActiveTab] = useState("published");
  const [academicYears, setAcademicYears] = useState([]);
  const axiosPrivate = useAxiosPrivate();
  const [Order, setOrder] = useState("academicName");
  const [OrderType, setOrderType] = useState(false);
  const [TypeStudent, setTypeStudent] = useState("-");
  const [post, setpost] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [bulkAction, setBulkAction] = useState("");
  const [showmessage, setShowMessage] = useState(false);
  const [rowId, setrowId] = useState([]);
  const [indexpage, setindexPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const { refreshKey } = useDataRefresh();
  const [showContactModal, setShowContactModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axiosPrivate.post(
        `${baseURL}/${ACADEMACYEARSDASHBORD}`,
        { Order, OrderType, TypeStudent, post, indexpage }
      );
      setAcademicYears(res.data.data || []);
      setTotalPages(res.data.totalPages || 1);
    } catch (err) {
      console.log(err);
      toast.error("حدث خطأ في تحميل البيانات");
    } finally {
      setLoading(false);
    }
  }, [axiosPrivate, Order, OrderType, TypeStudent, post, indexpage]);

  useEffect(() => {
    fetchData();
  }, [fetchData, refreshKey]);

  async function deleteItems(selectedIds) {
    try {
      const res = await axiosPrivate.delete(`${baseURL}/${DELETACASEC}`, {
        data: { ids: selectedIds },
      });
      toast.success("تم الحذف بنجاح");
      fetchData();
      setSelectedItems([]);
      setBulkAction("");
    } catch (err) {
      console.log(err);
      toast.error("خطأ في الحذف");
    }
  }

  const handleSelectItem = (id) => {
    setSelectedItems((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    if (selectedItems.length === academicYears.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(academicYears.map((item) => item.id));
    }
  };

  const handleBulkAction = () => {
    if (selectedItems.length === 0) {
      toast.error("الرجاء اختيار عناصر");
      return;
    }

    if (bulkAction === "delete") {
      if (window.confirm("هل تريد حذف العناصر المحددة؟")) {
        deleteItems(selectedItems);
      }
    }
  };

  const handlePaginationClick = (page) => {
    setindexPage(page);
  };

  const handleShowModal = (item) => {
    setSelectedItem(item);
    setShowContactModal(true);
  };

  const handleCloseContactModal = () => {
    setShowContactModal(false);
    setSelectedItem(null);
  };

  return (
    <div className="p-4 content" dir="rtl">
      <div className="d-flex align-items-center mb-5 justify-content-between">
        <h4 className="fw-bold m-0">المراحل الدراسية</h4>
        <Link
          to="/DashboardLayout/content/add"
          style={{ textDecoration: "none" }}
        >
          <Button className="custom-brand-btn-dhash">إضافة</Button>
        </Link>
      </div>

      {/* Tabs */}
      <Tabs
        activeKey={activeTab}
        onSelect={(k) => {
          setActiveTab(k);
          setpost(k === "drafts");
          setindexPage(1);
        }}
        className="mb-3"
        justify
      >
        <Tab eventKey="published" title="المنشورات" />
        <Tab eventKey="drafts" title="المسودات" />
      </Tabs>

      {/* Filters */}
      <div className="d-flex mb-3 gap-2 flex-wrap">
        <Form.Select
          style={{ maxWidth: "240px" }}
          value={bulkAction}
          onChange={(e) => setBulkAction(e.target.value)}
        >
          <option value="">تنفيذ على العناصر المحددة</option>
          <option value="delete">حذف</option>
        </Form.Select>

        <Button
          className="custom-brand-btn-dhash"
          variant="secondary"
          onClick={handleBulkAction}
          disabled={selectedItems.length === 0}
        >
          تطبيق
        </Button>

        <Dropdown dir="ltr" as={ButtonGroup}>
          <Dropdown.Toggle
            split
            variant="secondary"
            id="dropdown-split-basic"
            style={{
              backgroundColor: "var(--brand-200)",
              boxShadow: "0 3px 0px rgb(3, 42, 61)",
            }}
          />
          <Button
            className="custom-brand-btn-dhash"
            dir="ltr"
            variant="secondary"
          >
            النوع
          </Button>
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                setTypeStudent("general");
              }}
            >
              عام
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setTypeStudent("azhar");
              }}
            >
              أزهري
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setTypeStudent("-");
              }}
            >
              الكل
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Button
          onClick={() => {
            fetchData();
          }}
          className="custom-brand-btn-dhash"
          variant="outline-secondary"
        >
          فلتره
        </Button>
      </div>

      {/* Table */}
      <div className="table-responsive">
        <Table striped bordered hover className="align-middle text-center">
          <thead style={{ backgroundColor: "var(--brand-200)", color: "#fff" }}>
            <tr>
              <th style={{ textAlign: "center", width: "40px" }}>
                <Form.Check
                  type="checkbox"
                  checked={selectedItems.length === academicYears.length && academicYears.length > 0}
                  onChange={handleSelectAll}
                />
              </th>
              <th style={{ textAlign: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px",
                  }}
                >
                  <span>المرحله</span>
                  <span
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      fontSize: "12px",
                      cursor: "pointer",
                    }}
                  >
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder("academicName");
                        setOrderType(true);
                      }}
                      icon={faCaretUp}
                    />
                    <FontAwesomeIcon
                      onClick={() => {
                        setOrder("academicName");
                        setOrderType(false);
                      }}
                      icon={faCaretDown}
                    />
                  </span>
                </div>
              </th>
              <th style={{ textAlign: "center" }}>النوع</th>
              <th style={{ textAlign: "center" }}>عدد الطلاب</th>
              <th style={{ textAlign: "center" }}>عدد الوحدات</th>
              <th style={{ textAlign: "center" }}>التحكم</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  جاري التحميل...
                </td>
              </tr>
            ) : academicYears.length === 0 ? (
              <tr>
                <td colSpan="6" className="text-center py-4">
                  لا توجد بيانات
                </td>
              </tr>
            ) : (
              academicYears.map((level) => (
                <tr key={level.id}>
                  <td>
                    <Form.Check
                      type="checkbox"
                      checked={selectedItems.includes(level.id)}
                      onChange={() => handleSelectItem(level.id)}
                    />
                  </td>
                  <td>{level.name || level.academicName}</td>
                  <td>{level.type || level.academicType}</td>
                  <td>{level.studentsCount ?? level.usersCount ?? level.user_count ?? 0}</td>
                  <td>{level.chaptersCount ?? level.chapter_count ?? 0}</td>
                  <td>
                    <div className="d-flex gap-2 justify-content-center flex-wrap">
                      <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip>عرض التفاصيل</Tooltip>}
                      >
                        <Button
                          size="sm"
                          variant="outline-info"
                          onClick={() => handleShowModal(level)}
                          title="عرض"
                        >
                          <FontAwesomeIcon icon={faEye} />
                        </Button>
                      </OverlayTrigger>
                      <Link
                        to={`/DashboardLayout/content/update?id=${level.id}`}
                        style={{ textDecoration: "none" }}
                      >
                        <Button
                          size="sm"
                          variant="warning"
                          title="تعديل"
                        >
                          <FontAwesomeIcon icon={faPen} />
                        </Button>
                      </Link>
                      <Button
                        size="sm"
                        variant="danger"
                        title="حذف"
                        onClick={() => {
                          if (window.confirm("هل تريد حذف هذا العنصر؟")) {
                            deleteItems([level.id]);
                          }
                        }}
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center mt-4">
          <Pagination>
            <Pagination.First
              onClick={() => handlePaginationClick(1)}
              disabled={indexpage === 1}
            />
            <Pagination.Prev
              onClick={() => handlePaginationClick(indexpage - 1)}
              disabled={indexpage === 1}
            />
            {[...Array(Math.min(totalPages, 5))].map((_, i) => {
              const page = indexpage - 2 + i;
              if (page < 1 || page > totalPages) return null;
              return (
                <Pagination.Item
                  key={page}
                  active={page === indexpage}
                  onClick={() => handlePaginationClick(page)}
                >
                  {page}
                </Pagination.Item>
              );
            })}
            <Pagination.Next
              onClick={() => handlePaginationClick(indexpage + 1)}
              disabled={indexpage === totalPages}
            />
            <Pagination.Last
              onClick={() => handlePaginationClick(totalPages)}
              disabled={indexpage === totalPages}
            />
          </Pagination>
        </div>
      )}

      {/* Modal for viewing details */}
      <Modal
        show={showContactModal}
        onHide={handleCloseContactModal}
        centered
        dir="rtl"
      >
        <Modal.Header closeButton>
          <Modal.Title>تفاصيل المرحلة الدراسية</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedItem && (
            <div>
              <p>
                <strong>الاسم:</strong> {selectedItem.name || selectedItem.academicName}
              </p>
              <p>
                <strong>النوع:</strong> {selectedItem.type || selectedItem.academicType}
              </p>
              <p>
                <strong>عدد الطلاب:</strong> {selectedItem.user_count || 0}
              </p>
              <p>
                <strong>عدد الوحدات:</strong> {selectedItem.chapter_count || 0}
              </p>
              <p>
                <strong>تاريخ الإنشاء:</strong>{" "}
                {new Date(selectedItem.created_at).toLocaleDateString("ar-EG")}
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseContactModal}>
            إغلاق
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
